<bpc-widget [widgetClass]="'elevations-leaderboard'" [title]="title" [filters]="filters" (onFilterChange)="onFilterChange($event)">
  <!-- <bpc-highchart [chartOptions]="chartOptions"  *ngIf="!loading && data > 0" /> -->
    <section class="users-container" *ngIf="!loading else showLoaders">
      <div class="grid-row" *ngFor="let breakIn of data" [ngClass]="{ 'active': activeMember === breakIn }" (click)="showElevations(breakIn)">
        <img class="profile-image" [src]="breakIn.profilePictureUrl || 'assets/no-image.png'" />
        <span class="full-name">{{ breakIn.fullName }}</span>
        <div class="stat-block">
          <div class="stat-number">{{ breakIn.totalCompaniesElevated }}</div>
          <div class="stat-label">Elevations</div>
        </div>        
        <div class="stat-block">
          <div class="stat-number">{{ breakIn.totalBreakInElevations }}</div>
          <div class="stat-label">Break Ins</div>
        </div>
      </div>
    
      <div *ngIf="data.length === 0" class="no-data">
        <h2>No data available</h2>
      </div>
    </section>
    
  <ng-template #showLoaders>
    <bpc-dynamic-skeleton-loader [numberOfSkeletons]="loaders"></bpc-dynamic-skeleton-loader>
  </ng-template>
</bpc-widget>
